export default __webpack_public_path__ + "media/images/edit-74ed18ee1b3dcfd830f5709ce6def8dd.png";